import {
  addNavMenuItem,
  registerBulkAction,
  registerCustomDetailComponent,
} from "@bb-vendure/admin-ui/core";
import { PurchaseRequestCronjobSelectorComponent } from "./components/purchase-request-cronjob-selector/purchase-request-cronjob-selector.component";
import { bulkDeleteAction } from "./components/bulkAction";

export default [
  addNavMenuItem(
    {
      id: "purchase-cronjob",
      label: "nav.purchase-request-cron-job",
      routerLink: ["/extensions/request-cronjob"],
      icon: "hourglass",
      requiresPermission: (userPermissions) =>
        userPermissions.includes("ReadPurchaseRequestCronJob"),
    },
    "rule-section"
  ),

  // registerCustomDetailComponent({
  //   locationId: "product-detail",
  //   component: PurchaseRequestCronjobSelectorComponent,
  // }),

  registerBulkAction(bulkDeleteAction),
];
